import React, { useMemo, useState } from "react";
import modelMF from "./images/modela.png";
import modelMB from "./images/modelb.png";
import modelFF from "./images/modela-f.png";
import modelFB from "./images/modelb-f.png";
import bodyMap from "../../Utils/bodyMapSvg.json";
import "./anatomy-style.css";
import { Tooltip } from "@mui/material";
import { getNameFromKey } from "../../Utils/bodymap";

export const BodyMap = ({
  gender = "female",
  selected,
  availParts = [],
  data = {},
  playersPage = false
}) => {
  const [front, setFront] = useState(true);

  const handleToggle = () => {
    setFront(!front);
  };

  const dataForRender = useMemo(
    () => bodyMap[gender][front ? "front" : "back"],
    [gender, front]
  );

  const background = useMemo(() => {
    if (gender === "male") {
      return front ? modelMF : modelMB;
    } else {
      return front ? modelFF : modelFB;
    }
  }, [gender, front]);

  const getColor = (part) => {
    if (availParts.length > 0 && !availParts.includes(part)) return "gray";
    const colors = ["#b9e6b9", "#008000", "#ffd500", "#ff6b00", "#ff060b"];
    return colors[data[part]] || '#ffffff';
  };

  return (
    <div style={{ height: 400 }}>
      <svg
        version="1.1"
        viewBox={gender === "male" ? "0 0 800 1360" : "0 0 680 1320"}
        space="preserve"
        height="400"
      >
        <image
          overflow="visible"
          width={gender === "male" ? "800" : "680"}
          height={gender === "male" ? "1360" : "1320"}
          href={background}
        ></image>
        {Object.keys(dataForRender).length > 0 && Object.keys(dataForRender).map((key, i) => {
          if (data !== null && typeof data === "object" && 
              Object.keys(data).length > 0 && Object.keys(data).includes(key) && Object.keys(data[key]).length > 0 && 
              Object.keys(data[key]).includes('explain') && !playersPage){
            return (
              <Tooltip
                title={
                  data[key] ? (
                    <div style={{ fontSize: 14 }}>{`${
                      data[key]['explain']['count']
                    } of ${data[key]['explain']['total']} players selected ${getNameFromKey(key)}`}</div>
                  ) : null
                }
                placement="left"
                arrow
                key={`${key}_${i}`}
              >
                <path
                  fill="#8A0707"
                  stroke={"#8C8C8C"}
                  fillOpacity={data[key]?.['value'] || 0}
                  // className={[key] && "mfb-part"}
                  vector-effect="non-scaling-stroke"
                  d={dataForRender[key]}
                />
              </Tooltip>
            ) 
          } else return (
            <path
              fill={getColor(key)}
              stroke={"#8C8C8C"}
              fillOpacity={0.3}
              // className={[key] && "mfb-part"}
              vector-effect="non-scaling-stroke"
              d={dataForRender[key]}
              key={`${key}_${i}`}
            />
          )
        })}
        <rect
          className="mfb-gob"
          x={gender === "male" ? "598.5" : "478.5"}
          y={gender === "male" ? "1058.5" : "1019.5"}
          fill="#8C8C8C"
          fillOpacity={0}
          stroke="#8C8C8C"
          vector-effect="non-scaling-stroke"
          width="181"
          height="271"
          onClick={handleToggle}
        />
      </svg>
    </div>
  );
};
